import { render, staticRenderFns } from "./VehicleSalesView.vue?vue&type=template&id=57b70f9c&"
import script from "./VehicleSalesView.vue?vue&type=script&lang=js&"
export * from "./VehicleSalesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports